import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import username from 'flarum/common/helpers/username';
import UserPage from 'flarum/forum/components/UserPage';
import Placeholder from 'flarum/common/components/Placeholder';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import extractText from 'flarum/common/utils/extractText';
export default class ProfilePage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.ignoredUsers = [];
    this.loadUser(app.session.user.username());

    // Loaded here rather than with every page, and fresh each time the page opens.
    app.store.find('users', app.session.user.id(), {
      include: 'ignoredUsers'
    }).then(user => {
      this.ignoredUsers = user.ignoredUsers() || [];
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "DiscussionList"
      }, m(LoadingIndicator, null));
    }
    if (this.ignoredUsers.length === 0) {
      return m("div", {
        className: "DiscussionList"
      }, m(Placeholder, {
        text: app.translator.trans('fof-ignore-users.forum.profile_page.no_ignored')
      }));
    }
    return m("table", {
      className: "NotificationGrid"
    }, this.ignoredUsers.map((user, i) => {
      const unignore = () => {
        if (confirm(extractText(app.translator.trans(`fof-ignore-users.forum.user_controls.unignore_confirmation`)))) {
          user.save({
            ignored: false
          });
          this.ignoredUsers.splice(i, 1);
        }
      };
      return m("tr", null, m("td", null, m(Link, {
        href: app.route.user(user)
      }, m("h3", null, m(Avatar, {
        user: user,
        className: "ignorePage-avatar"
      }), " ", username(user)))), m("td", {
        className: "ignorePage-button"
      }, m(Button, {
        icon: "fas fa-comment",
        type: "button",
        className: "Button Button--warning",
        onclick: unignore.bind(user)
      }, app.translator.trans('fof-ignore-users.forum.user_controls.unignore_button'))));
    }));
  }
  show(user) {
    this.user = app.session.user;
    m.redraw();
  }
}
flarum.reg.add('fof-ignore-users', 'forum/components/ProfilePage', ProfilePage);